import { defineDirective, FieldsMap, IFieldsMapContainerContext, OmniaModuleId, SharedFieldsService, str } from "./omnia"
import { IFieldsEditService, IFieldsModuleContext, IFieldsService } from "./types"

enum View {
    Timeline = "timeline",
    Map = "map"
}

export class FieldsModule extends omnia.shell.Module {

    static create(): ng.IDirective {

        return defineDirective(FieldsModule, "app/fields/fields.html")

    }

    private _view: View

    private fieldsMap: FieldsMap
    private _ctxt: IFieldsModuleContext

    static $inject = ["$scope", "OmniaFieldsService", "OmniaFieldsEditService", "OmniaFieldsMapContext"]

    constructor(
        $scope: ng.IScope,
        private svc: IFieldsService,
        private editSvc: IFieldsEditService,
        private mapCtxt: IFieldsMapContainerContext) {

        super($scope, mapCtxt.shell, "icon-holding-fields", str.Modules.Fields, OmniaModuleId.Fields)

    }

    $onInit() {

        this._view = this.svc.mapView ? View.Map : View.Timeline

        this.setupMap()
        this.updateContext()
        this.register()

        this.startFirstComponent("omnia-fields-menu", () => this.refresh())

    }

    get initialComponentWidth(): number {
        const ctxt = this.getCurrentContext()
        return ctxt ? ctxt.width : 0
    }

    isPinnable(): boolean {
        return this.timelineView ? false : super.isPinnable()
    }

    protected dispose() {

        this.fieldsMap.dispose()

    }

    private setupMap() {

        this.fieldsMap = new FieldsMap(this.mapCtxt, {
            viewDefaultExtent: true,
            showDisabledFields: true,
            canSelectFields: true
        })

        this.$scope.$watch("vm.svc.selectedItems", () => this.fieldsMap.updateMapSelection());

        this.$scope.$watch("vm.svc.lastLocatedItems", ({ items }: SharedFieldsService["lastLocatedItems"]) => {
            this.fieldsMap.showFeaturesWithData(items, true);
        });

        this.$scope.$watch("vm.mapView", () => this.updateContext());

    }

    private register() {

        this.registerComponent("omnia-fields-menu", {
            width: 350,
            attrs: { "context": "vm.context" },
            visible: () => !this.timelineView
        });

        [
            "edit-fields",
            "edit-croppings",
            "split-cropping",
            "merge-cropping",
            "edit-infield-features",
            "edit-grass-margin"
        ].forEach(key => {

            this.registerComponent("omnia-fields-" + key, {
                width: 350,
                attrs: { "fields-map": "vm.fieldsMap" },
                refreshOnClose: true
            })

        })

    }

    refresh() {
        return this.svc.refresh()
    }

    get context(): IFieldsModuleContext {
        return this._ctxt;
    }

    get componentWidth() {
        return this.initialComponentWidth
    }

    get view() {
        return this._view
    }

    set view(value) {
        this._view = value
        this.setView(value == View.Map)
    }

    get mapView(): boolean {
        return this.svc.mapView;
    }

    get timelineView(): boolean {
        return this.svc.timelineView;
    }

    public setView(map: boolean) {
        this.svc.setView(map)
        this.updateContext()
    }

    private updateContext() {

        if (!this.fieldsMap) {
            this._ctxt = null;
            return;
        }

        this._ctxt = {

            svc: this.svc,
            editSvc: this.editSvc,
            shell: this.shell,
            readOnly: this.session.isReadOnly(p => p.fields),

            startComponent: options => this.startComponent(options),

            map: this.fieldsMap,
            mapView: this.mapView

        }

    }

}


